
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Tilføj den til din hjemmeskærm for en bedre oplevelse og nem adgang.`,
's1b9047d53d9f9d22': `2) Tryk på Del-knappen i navigationslinjen`,
's37a9e8aec5713460': `Mere`,
's5c6aad7a7e4a1437': `3) Vælg Tilføj til hjemmeskærm`,
's6196153c4b0c1ea0': `Installer`,
's922329d6f6213590': `Tilføj til Dock`,
'sa5ef80b4bb9b39f8': `Mindre`,
'sa7551383d1897fcc': `2) Vælg Tilføj til Dock`,
'sba52286c21552a4e': `Installer den på din enhed for en bedre oplevelse og nem adgang.`,
'sc79fd7641eb9a975': `Skjul instruktion`,
'scdaf4bbff76674c8': `Tilføj til hjemmeskærm`,
'sdfe23506a3b0cdc8': `1) Åbn i Safari-browseren`,
'se740f75b95a51807': `Tilføj den til din Dock for en bedre oplevelse og nem adgang.`,
'sfea652f6580ff086': `Denne side har app-funktionalitet.`,
    };
  